
<template>
    <Layout>
        <template v-slot:title v-if="isOnIntegratedClub">
            No video uploaded... yet
        </template>
      <template v-slot:title v-else>
        This athlete has not uploaded video yet
      </template>

        <template v-slot:body v-if="canRequest">
            <div class="mb-4">
                Request video from {{athleteName}}'s coach.
                This is not visible to the athlete.
            </div>

            <VideoRequestButton source="video_section" />
        </template>
    </Layout>
</template>

<script>
    import Layout from '../../EmptyStateLayout.vue'
    import VideoRequestButton from '@/components/FeedbackRequest/Types/Video'
    import { mapGetters } from 'vuex'

    export default {
        components: { VideoRequestButton, Layout },

        props: {
            athlete: { type: Object, required: true },
        },

        computed: {
          ...mapGetters('athleteProfile', ['canSendFeedbackRequest', 'isOnIntegratedClub']),
            athleteName() {
                return this.athlete.firstName
            },
            canRequest() {
                return this.canSendFeedbackRequest
            },
        },
    }
</script>